<template>
  <FileDialogWrapper @close="$emit('close')">
    <template #header>
      <h3>
        <v-btn icon @click="$emit('back')">
          <v-icon size="24">mdi-chevron-left</v-icon>
        </v-btn>

        {{ $t("message.common.addFile") }}
      </h3>
    </template>
    <template>
      <input
        id="uploadInput"
        ref="input"
        type="file"
        class="d-none"
        @change="setImage"
      />

      <div class="upload">
        <div class="upload__content">
          <template v-if="!file">
            <v-icon size="48" color="gray">mdi-folder-open</v-icon>
            <ui-button
              color="primary"
              class="btn--add-photo"
              @click="handleChangeBtn"
              >{{ $t("message.common.select") }}</ui-button
            >
          </template>
          <template v-else>
            <div class="file">
              <v-icon size="24" color="gray">mdi-file-outline</v-icon>
              <span>{{ fileName }}</span>
              <ui-button
                transparent
                small
                :text-color="primaryColor"
                @click="handleChangeBtn"
                >{{ $t("message.common.change") }}</ui-button
              >
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-if="file" #actions>
      <ui-button color="primary" outlined @click="$emit('close')">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button color="primary" @click="uploadFile">
        {{ $t("message.common.upload") }}
      </ui-button>
    </template>
    <SectionLoader :status="isLoading" />
  </FileDialogWrapper>
</template>

<script>
import facilitiesService from "@/services/facilities";
import serviceHandler from "@/helpers/handlers/service";
import { textTruncate } from "@/helpers/helpers";
import FileDialogWrapper from "@/components/BusinessAddresses/FileDialogWrapper";
import { APP_COLORS } from "@/config/app-colors.js";

export default {
  name: "ImportFileDialogContent",
  components: {
    FileDialogWrapper,
    SectionLoader: () => import("@/components/Loader/SectionLoader")
  },
  props: {
    selectedColumns: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      file: null,
      isLoading: false,
      primaryColor: APP_COLORS.PRIMARY
    };
  },
  computed: {
    fileName() {
      return textTruncate(this.file.name, 35);
    }
  },
  methods: {
    setImage(e) {
      this.file = e.target.files[0];
    },
    handleChangeBtn() {
      document.getElementById("uploadInput").click();
    },
    async uploadFile() {
      if (this.file) {
        this.isLoading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        this.selectedColumns.forEach(column => {
          formData.append("fields", column);
        });

        try {
          const {
            data: token
          } = await facilitiesService.importFacilityEditFile(formData);
          await serviceHandler(facilitiesService.putFacilitiesImport(token));

          this.$notify({
            group: "default",
            type: "success",
            text: this.$t("message.facilitiesEdit.editSuccess")
          });
        } catch (err) {
          this.$notify({
            group: "default",
            type: "error",
            text: this.$t("message.error.other")
          });
        }
        this.isLoading = true;
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upload {
  margin-bottom: $spacing * 2;
  border-radius: 16px;
  background: $base-light;
  padding: $spacing * 4;
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $spacing;
  }
}
.file {
  display: flex;
  align-items: center;
  gap: $spacing;
}
</style>
